import { render, staticRenderFns } from "./PcBanner.vue?vue&type=template&id=71303c96&scoped=true"
import script from "./PcBanner.vue?vue&type=script&lang=js"
export * from "./PcBanner.vue?vue&type=script&lang=js"
import style0 from "./PcBanner.vue?vue&type=style&index=0&id=71303c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71303c96",
  null
  
)

export default component.exports